<input
  class="currency-input"
  type="text"
  inputmode="decimal"
  autocomplete="off"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [maskito]="mask"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)"
  (blur)="handleBlur()" />
